import { render, staticRenderFns } from "./Sobre.vue?vue&type=template&id=3e371c91&scoped=true"
import script from "./Sobre.vue?vue&type=script&lang=js"
export * from "./Sobre.vue?vue&type=script&lang=js"
import style0 from "./Sobre.vue?vue&type=style&index=0&id=3e371c91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e371c91",
  null
  
)

export default component.exports